import React from "react";
import { PASSWORD_PROTECTED } from "../../actions/actionTypes";
import { useDispatch } from "react-redux";
import { useFileRemoval } from "../../helpers/useFileRemoval";
import ErrorPopup from "./ErrorPopup";

const PasswordProtected = ({
  allFiles,
  setAllFiles,
  allProcessedFiles,
  setAllProcessedFiles
}) => {
  const dispatch = useDispatch();

  const { handleDelete, redirectToUpload } = useFileRemoval({
    allFiles,
    setAllFiles,
    allProcessedFiles,
    setAllProcessedFiles,
  });

  const onTryAgain = () => {
    dispatch({ type: PASSWORD_PROTECTED, payload: false });
    handleDelete();
    redirectToUpload();
  };

  return (
    <ErrorPopup onTryAgain={onTryAgain}>
      <div className="upload-title-text">
        Upload failed!
      </div>
      <div className="upload-content-text">
        Password-protected files are not supported.
      </div>
      <div className="upload-content-text">
        {" "}
        Please upload an unprotected PDF
      </div>
    </ErrorPopup>
  );
};

export default PasswordProtected;
